// 表示モードのURL同期とlocalStorage保持
import { ref } from 'vue';

const DEFAULT_VIEW_MODE = 'grid';
const STORAGE_KEY = 'exa_dashboard_view_mode';

const normalizeMode = (mode) => (mode === 'list' || mode === 'grid' ? mode : null);

export const useViewMode = () => {
  const viewMode = ref(DEFAULT_VIEW_MODE);

  const syncViewPreference = (mode) => {
    const inputs = document.querySelectorAll('input[name="view"]');
    inputs.forEach((input) => {
      input.value = mode;
    });

    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has('view')) {
        url.searchParams.delete('view');
        window.history.replaceState({}, '', url.toString());
      }
    } catch (error) {
      // noop: URL API not available
    }
  };

  const setViewMode = (mode) => {
    if (!normalizeMode(mode)) {
      return;
    }
    viewMode.value = mode;
    syncViewPreference(mode);
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      // ignore storage errors (e.g. private mode)
    }
  };

  const initViewMode = (dataSource) => {
    const storedMode = (() => {
      try {
        return window.localStorage.getItem(STORAGE_KEY);
      } catch (error) {
        return null;
      }
    })();

    const urlViewParam = (() => {
      try {
        const url = new URL(window.location.href);
        return url.searchParams.get('view');
      } catch (error) {
        return null;
      }
    })();

    const serverDefaultMode =
      (dataSource && dataSource.getAttribute('data-view-mode')) || DEFAULT_VIEW_MODE;

    const initialMode =
      normalizeMode(storedMode) ||
      normalizeMode(urlViewParam) ||
      normalizeMode(serverDefaultMode) ||
      DEFAULT_VIEW_MODE;

    setViewMode(initialMode);
  };

  return {
    viewMode,
    setViewMode,
    initViewMode,
  };
};
